export const DATE_FORMAT_DEFAULT = 'dd/mm/yy HH:MM';
export const DAY_MONTH_YEAR_HOURS = 'DD/MM/YYYY HH:MM';
export const DATE_FORMAT_DEFAULT_DOT = 'dd.mm.yy HH:MM';
